import { cn } from "@workspace/ui/lib/utils";
import type * as React from "react";

type CalloutProps = {
  icon?: string;
  children?: React.ReactNode;
  type?: "default" | "warning" | "danger";
};

export function Callout({
  children,
  icon,
  type = "default",
  ...props
}: CalloutProps) {
  return (
    <div
      className={cn("my-6 flex items-start rounded-md border border-l-4 p-4", {
        "border-score-red bg-score-red-soft": type === "danger",
        "border-score-amber bg-score-amber-soft": type === "warning",
      })}
      {...props}
    >
      {icon && <span className="mr-4 text-2xl">{icon}</span>}
      <div>{children}</div>
    </div>
  );
}
